<template>
  <PrestationsPage
    title_1="Soins"
    title_2="Corps"
    :sections="sections"
    :images="images" />
</template>

<script>
import GlobalMixin from '@/mixins/global.mixin'
import { Component } from 'vue-property-decorator'
import PrestationsPage from '@/components/PrestationsPage'

@Component({
  components: {
    PrestationsPage
  }
})

export default class Page extends GlobalMixin {

  data() {
    return {
      images: undefined,

      sections: [
        {
          title: 'Bien-être',
          subSections: [
            {
              title: 'Sauna Dôme',
              items: [
            
                {
                  name: 'Sauna japonais aux infrarouges longs & aux pierres minérales - Relaxation, détox, amincissant',
                  alternatives: [
                    {
                      description: 'Séance',
                      duration: '30 min',
                      price: '35€',
                    },
                    {
                      description: 'Les 5 séances',
                      duration: '',
                      price: '165€',
                    },
                    {
                      description: 'Les 10 séances',
                      duration: '',
                      price: '299€',
                    },
                    {
                      description: 'Les 20 séances',
                      duration: '',
                      price: '559€',
                    },
                  ]
                },
              ]
            }
          ]
        },
        {
          title: 'Les Massages',
          subSections: [
            {
              title: 'Le dos',
              subtitle: 'Merci d’arriver 10min avant le rendez-vous',
              items: [
                {
                  name: 'Modelage du dos',
                  alternatives: [
                    {
                      description: '',
                      duration: '30 min',
                      price: '40€',
                    },
                  ]
                },
                {
                  name: 'Soin détente du dos',
                  alternatives: [
                    {
                      description: 'Gommage et Modelage du Dos.',
                      duration: '45 min',
                      price: '52€',
                    },
                  ]
                },
                {
                  name: 'Soin décontractant et remineralisant',
                  alternatives: [
                    {
                      description: 'Gommage, Modelage et Enveloppement du Dos.',
                      duration: '60 min',
                      price: '62€',
                    },
                  ]
                }
              ]
            },
            {
              title: 'Le Corps',
              items: [
                {
                  name: 'Soin Gomant',
                  alternatives: [
                    {
                      description: 'Pour le Corps',
                      duration: '30 min',
                      price: '39€',
                    },
                    {
                      description: 'Gommage en plus d’un massage',
                      duration: '',
                      price: '30€',
                    },
                  ]
                },
                {
                  name: 'Le Beauté Relaxant',
                  alternatives: [
                    {
                      description: 'Enveloppement et Modelage au Beurre de Karité.',
                      duration: '75 min',
                      price: '82€',
                    },
                  ]
                },
                {
                  name: 'Le californien',
                  alternatives: [
                    {
                      description: 'Relaxant par excellence, composé de longs effleurages, pétrissages musculaires. C\'est une véritable relaxation musculaire, idéale en récupération.',
                      duration: '30 min',
                      price: '50€',
                    },
                    {
                      description: '',
                      duration: '45 min',
                      price: '59€',
                    },
                    {
                      description: '',
                      duration: '60 min',
                      price: '74€',
                    },
                  ]
                },
                {
                  name: 'Le Lomi-Lomi Hawaïen',
                  alternatives: [
                    {
                      description: 'Le modelage Hawaïen baptisé "Lomi-Lomi" est un modelage complet du visage et du corps très relaxant. Sa particularité réside dans le fait que ce sont les avant-bras, les mains et les coudes du donneur qui travaillent. Ainsi, la personne massée est enveloppée par des mouvements lents, rapide et doux. Cette sensation d\'être bercé au gré des vagues de l\'océan est toujours présente. Surprenant pour celui ou celle qui le reçoit.',
                      duration: '75 min',
                      price: '86€',
                    },
                  ]
                },
                {
                  name: 'L\'ABHYANGA - AYURVEDA',
                  alternatives: [
                    {
                      description: 'L\'Abhyanga est un modelage décontractant et profond à l\'huile chaude, du visage,du crâne, du cuir chevelu et du corps. L\'objectif est de restaurer l\'équilibre des énergies,il harmonise le corps et l\'esprit, il apaise les tensions et redonne énergie et vitalité,il lutte contre la fatigue générale, l\'agitation mentale et favorise l\'apaisement mental.',
                      duration: '75 min',
                      price: '86€',
                    },
                  ]
                },
                {
                  name: 'Modelage zones réflexes des pieds',
                  alternatives: [
                    {
                      description: 'Comment imaginer qu\'en massant les pieds, tout le corps en ressente les bienfaits. Modelage des pieds, pressions des zones réflexes plantaires.',
                      duration: '45 min',
                      price: '45€',
                    },
                  ]
                },
              ]
            },
            {
              title: 'Le Corps - Soins minceur et raffermissant.',
              items: [
                {
                  name: 'Consultation',
                  alternatives: [
                    {
                      description: 'Offert pour l\'achat d\'une Cure et suivi.',
                      duration: '60 min',
                      price: '60€',
                    },
                  ]
                },
                {
                  name: 'Soin Minceur « Multi Slim »',
                  alternatives: [
                    {
                      description: 'Méthode de soin Manuelle - Modelage Personnalisé et Enveloppement Minceur Anti-Graisse, Anti-Eau.',
                      duration: '60 min',
                      price: '65€',
                    },
                  ]
                },
                {
                  name: 'Sauna Dôme + Enveloppement Sudatonic',
                  alternatives: [
                    {
                      description: 'Forfait 5 séances',
                      duration: '75 min',
                      price: '300€',
                    },
                  ]
                },
                {
                  name: 'Modelage D-TOX',
                  alternatives: [
                    {
                      description: 'Digestion, émotions, régénération, tout est lié… \n\nCe soin Détox visant à libérer les flux énergétiques, éliminer les toxines et favoriser un fonctionnement optimal du corps, en mettant l’accent sur  la région Ventrale.Résultat: une détoxification de l’organisme, une silhouette harmonieuse, rajeunie et tonique.',
                      duration: '60 min',
                      price: '99€',
                    },
                  ]
                },
                {
                  name: 'Soin Active Wrap',
                  alternatives: [
                    {
                      description: 'Affine, Tonifie & Raffermit. Bioslimming Active Wrap est un enveloppement amincissant innovant qui se concentre sur la réduction de la cellulite et de la graisse. Ce processus thermique stimule la micro-circulation et cible les cellules graisseuses, améliore l’apparence de la cellulite et favorise la perte de poids tout en gardant la peau ferme et tonifiée.',
                      duration: '60 min',
                      price: '99€',
                    },
                  ]
                },
              ]
            },
          ]
        },
        {
          title: 'LIFT & SHAPE',
          subSections: [
            { 
              title: 'Onda Dinamica',
              subtitle: 'En cure pour un traitement en profondeur',

              items: [
 
                {
                  name: 'Un dispositif unique pour tout soin du corps  ',
                  alternatives: [
                    {
                      description: '1 ou 2 zone(s) cellulite, fibrose, atonie, rétention d’eau, vascularisation, remodelage',
                      duration: '1 Zone',
                      price: '90€',
                    },
                    {
                      description: '',
                      duration: '2 Zones',
                      price: '175€',
                    }
                  ]
                },
              ]
            },
          ]
        }, 






      ],

    }
  }

  mounted()
  {
    this.$store.commit('setPageLoadState', true)
  }





}

</script>
